<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
    class="px-0"
    style="height: auto;padding-top: 1px !important;"
  >
    <board ref="refBoard" />
    <v-fab-transition>
      <v-menu
        top
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            v-bind="attrs"
            fab
            bottom
            x-small
            left
            style="position: fixed;bottom: 20px;left:60px"
            class="v-btn--example flex-column-reverse"
            v-on="on"
          >
            <v-icon>
              mdi-gamepad-circle-outline
            </v-icon>
          </v-btn>
        </template>

        <v-list
          dense
          width="200"
        >
          <v-list-item
            style="height: 30px"
            @click="$router.push({ name: 'TaskList' })"
          >
            <v-list-item-title>{{ $t('tasks') }}</v-list-item-title>
            <v-list-item-action>
              <v-icon color="green">
                mdi-format-list-bulleted-square
              </v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-list-item
            style="height: 30px"
            @click="$router.push({ name: 'Sell' })"
          >
            <v-list-item-title>{{ $t('sell') }}</v-list-item-title>
            <v-list-item-action>
              <v-icon color="blue">
                mdi-cart-outline
              </v-icon>
            </v-list-item-action>
          </v-list-item>
          <v-list-item
            style="height: 30px"
            @click="accountDialog = true"
          >
            <v-list-item-title>{{ $t('new-account') }}</v-list-item-title>
            <v-list-item-action>
              <v-icon color="pink">
                mdi-account-plus-outline
              </v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-fab-transition>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="accountDialog"
      width="95%"
    >
      <v-card>
        <v-col class="d-flex pt-2 pb-0">
          <v-btn
            icon
            @click="accountDialog = false"
          >
            <v-icon
              class="close-hover"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('new-account') }}
          </p>
        </v-col>
        <v-card-text class="pa-0">
          <div
            class="overflow-y-auto ma-2 mt-0"
            style=" height: 350px"
          >
            <account
              @close="accountDialog = false"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-dialog
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      v-model="taskDialog"
      width="90%"
    >
      <v-card>
        <v-col
          class="d-flex"
        >
          <v-btn
            icon
            @click="taskDialog = false"
          >
            <v-icon
              class="close-hover"
              color="grey"
              large
            >
              mdi-close
            </v-icon>
          </v-btn>
          <p class="mx-auto font-weight-medium mt-2">
            {{ $t('task') }}
          </p>
        </v-col>
        <v-row class="ma-0">
          <task
            ref="refTask"
            task-type="account"
            @close="taskDialog = false"
          />
        </v-row>
        <v-card-actions />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import Account from './pages/account/customer'
  import Task from '../dashboard/pages/task/task'
  export default {
    name: 'Dashboard',
    components: {
      Board: () => import('../dashboard/pages/widgets/Board'),
      Task,
      Account,
    },
    data () {
      return {
        taskDialog: null,
        index: 0,
        accountDialog: false,
        eventLog: [],
        component: null,
        componentData: null,
        tabs: 0,
        list: {
          0: false,
          1: false,
          2: false,
        },
      }
    },
    watch: {
      taskDialog () {
        if (!this.taskDialog) {
          this.$refs.refBoard.getItems()
        }
      },
    },
    mounted () {
    },
    methods: {
      removeItem: function (val) {
        const index = this.layout.map(item => item.i).indexOf(val)
        this.layout.splice(index, 1)
      },
      dashload (link) {
        this.component = link
      },
      complete (index) {
        this.list[index] = !this.list[index]
      },
      getData (data) {
        this.componentData = data
        this.$refs.comp.test(data)
      },
    },
  }
</script>
